export enum PickupColumnEnum {
    PICKUP_REFERENCE = 'PICKUP_REFERENCE',
    PICKUP_DATE = 'PICKUP_DATE',
    PICKUP_COURIER = 'PICKUP_COURIER',
    PICKUP_TIME_START = 'PICKUP_TIME_START',
    PICKUP_TIME_END = 'PICKUP_TIME_END'
}
